
import { Component, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import MyScroller from '@/components/my-scrollbar/index.vue'
import Role from '@/entities/role'

@Component({
  components: { CardBody, MyScroller }
})
export default class RoleEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'RoleEdit'

  loading: boolean = false

  defaultProps: object = {
    children: 'children',
    label: 'displayName'
  }

  role: Role = new Role()

  permissonError: string = ''

  rules = {
    displayName: [
      {
        required: true,
        message: 'Please input Role Name',
        trigger: 'blur'
      }
    ],
    // 2026-08-24 - Added by AI (CR-26-08) - optional, but exactly 6 alphanumeric when provided
    rolePasscode: [
      {
        pattern: /^([A-Za-z0-9]{6})?$/,
        message: 'Passcode must be exactly 6 alphanumeric characters',
        trigger: 'blur'
      }
    ]
  }

  defaultCheckedKeys = []

  // tree条件过滤
  filterText: string = ''

  @Watch('filterText')
  treeDataFilter(val) {
    ;(this.$refs.tree as any).filter(val)
  }

  filterNode(val, data) {
    if (!val) return true
    return data.displayName.indexOf(val) !== -1
  }

  // 调用接口
  async createOrUpdateRole(data) {
    await this.$store.dispatch({
      type: 'role/createOrUpdateRole',
      data: data
    })
    this.$notify.success({
      title: 'Success',
      message: 'Save Success'
    })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  treeData = []

  // 获取所有权限
  async getAllPermissions() {
    await this.$store.dispatch({
      type: 'role/getAllPermissions'
    })
    this.treeData = this.arrayToTree(this.allPermissions)
  }

  // 所有的权限
  get allPermissions() {
    return this.$store.state.role.permissions
  }

  // 数组转树
  arrayToTree(data) {
    let cloneData = JSON.parse(JSON.stringify(data))
    return cloneData.filter(parent => {
      let branchArr = cloneData.filter(
        child => parent['name'] == child['parentName']
      )
      branchArr.length > 0 ? (parent['children'] = branchArr) : ''
      return parent['parentName'] === null
    })
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      let checkedKeys = (this.$refs.tree as any).getCheckedKeys()
      // 保存role的时候需要可以不选权限
      // if (!checkedKeys || !checkedKeys.length) {
      //   this.$message.warning('Please select Role Permissons')
      //   return
      // }
      this.createOrUpdateRole({
        role: {
          ...this.role
        },
        grantedPermissionNames: checkedKeys
      })
    })
  }

  async created() {
    try {
      this.loading = true
      let id = +this.$route.params.id
      if (!id || id < 0) {
        // 新增
        await this.getAllPermissions()
        return
      }
      // 编辑
      this.role.id = +id
      let res = await this.$store.dispatch({
        type: 'role/get',
        id: this.$route.params.id
      })
      this.role = res.role
      this.defaultCheckedKeys = []
      res.permissions.map(t => {
        res.grantedPermissionNames.map(n => {
          if (n === t.name) {
            this.defaultCheckedKeys.push(t.name)
          }
        })
      })
      this.treeData = this.arrayToTree(res.permissions)

      if(this.role.id == 1)
        this.$message.warning('Admin permissions cannot be modified.')

    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }
}
